import { Component, OnInit } from '@angular/core';
import { Fuel, FuelPolicy, FlightWeightUnit } from '@app/flight-planning/flight-plan-constant';
import { FlightPlanService } from '@app/flight-planning/route-plan/services/flight-plan.service';

@Component({
    selector: 'app-route-fuel',
    templateUrl: './fuel.component.html',
    styleUrls: ['./fuel.component.scss'],
    standalone: false
})
export class FuelComponent implements OnInit {
  public fuelPolicyType = FuelPolicy;
  public FlightWeightUnit = FlightWeightUnit;
  constructor(public flightPlanService: FlightPlanService) {}
  public ngOnInit() {}
  public openAccordian() {
    this.flightPlanService.accordionSwitch('flightplanfuel');
  }

}
